import React from 'react'
import { orderBy } from 'lodash'
import moment from 'moment'
import decode from 'jwt-decode'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Icon from '@material-ui/core/Icon'
import IconButton from '@material-ui/core/IconButton'

import { Field } from 'formik'
import { Radio } from '@material-ui/core'

import useFirebase from '../../useFirebase'

export default function ProposalSelector({ data, setUrl }) {
  const firebase = useFirebase()
  const storage = firebase.storage()

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell />
          <TableCell>N. Documento</TableCell>
          <TableCell>Vencimento</TableCell>
          <TableCell align="center">
            <IconButton
              aria-label="limpar seleção"
              onClick={() => setUrl(null)}>
              <Icon color="secondary">cancel</Icon>
            </IconButton>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.documents &&
          orderBy(data.documents, ['due_date'], ['desc']).map(row => {
            return (
              <TableRow key={row.id}>
                <TableCell align="center" style={{ width: 48, padding: 0 }}>
                  <Field
                    name="parent_id"
                    render={({
                      field /* { name, value, onChange, onBlur } */
                    }) => (
                      <Radio
                        {...field}
                        onChange={(...args) => {
                          field.onChange(...args)
                        }}
                        value={row.id}
                        checked={field.value === row.id}
                      />
                    )}
                  />
                </TableCell>
                <TableCell>{row.cod}</TableCell>
                <TableCell>
                  {moment(row.due_date).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell align="center" style={{ width: 48, padding: 0 }}>
                  <IconButton
                    aria-label="visualizar"
                    onClick={() => {
                      const user = decode(window.token)
                      const pathReference = storage.ref(
                        `orgs/${user.org}/docs/${row.id}.pdf`
                      )
                      pathReference.getDownloadURL().then(url => setUrl(url))
                    }}>
                    <Icon color="secondary">remove_red_eye</Icon>
                  </IconButton>
                </TableCell>
              </TableRow>
            )
          })}
      </TableBody>
    </Table>
  )
}
